import { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Container } from '@mui/material';
import FMSToolbar from 'src/common/FMSToolbar';
import FilterSelectInput from 'src/common/FilterSelectInput';
import NewDriver from 'src/components/drivers/NewDriver';
import DriverListTable from 'src/components/drivers/DriverListTable';
import ScreenHeader from 'src/common/ScreenHeader';
import useAdminSiteFilter from 'src/hooks/useAdminSiteFilter';

const Drivers = ({ location }) => {
  const {
    isAdmin,
    siteFilter,
    setSiteFilter,
    siteOptions
  } = useAdminSiteFilter();
  const [openModal, setOpenModal] = useState(false);
  const [searchText, setSearchText] = useState('');

  const handleSearch = (str) => setSearchText(str);

  return (
    <>
      <ScreenHeader title="Drivers" />
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <FMSToolbar
            placeholder="Search Driver Name"
            actionName="Add Driver"
            onSearch={handleSearch}
            onAction={() => setOpenModal(true)}
          >
            {isAdmin && (
              <FilterSelectInput
                label="Site"
                name="site"
                value={siteFilter}
                data={siteOptions}
                onInputChange={setSiteFilter}
                sx={{ width: { xs: '100%', sm: 220, md: 180 }, mr: 0 }}
              />
            )}
          </FMSToolbar>
          <NewDriver open={openModal} handleClose={() => setOpenModal(false)} />
          <Box sx={{ pt: 3 }}>
            <DriverListTable
              refreshData={location.state?.fromDashboard}
              searchText={searchText}
              siteFilter={siteFilter}
            />
          </Box>
        </Container>
      </Box>
    </>
  );
};

Drivers.propTypes = {
  location: PropTypes.object
};

export default Drivers;
